module.exports = __webpack_public_path__ + "static/media/des-icon-2.92fcd416.svg";